import am5geodata_iranLow from '@amcharts/amcharts5-geodata/iranLow';
import am5geodata_afghanistanLow from '@amcharts/amcharts5-geodata/afghanistanLow';
import am5geodata_turkmenistanLow from '@amcharts/amcharts5-geodata/turkmenistanLow';
import am5geodata_sudanLow from '@amcharts/amcharts5-geodata/sudanLow';
import am5geodata_chadLow from '@amcharts/amcharts5-geodata/chadLow';
import am5geodata_ethiopiaLow from '@amcharts/amcharts5-geodata/ethiopiaLow';
import am5geodata_azerbaijanLow from '@amcharts/amcharts5-geodata/azerbaijanLow';
import am5geodata_eritreaLow from '@amcharts/amcharts5-geodata/eritreaLow';
import am5geodata_burkinaFasoLow from '@amcharts/amcharts5-geodata/burkinaFasoLow';
import am5geodata_maliLow from '@amcharts/amcharts5-geodata/maliLow';
import am5geodata_nigerLow from '@amcharts/amcharts5-geodata/nigerLow';
import am5geodata_somaliaLow from '@amcharts/amcharts5-geodata/somaliaLow';
import am5geodata_pakistanLow from '@amcharts/amcharts5-geodata/pakistanLow';
import am5geodata_romaniaLow from '@amcharts/amcharts5-geodata/romaniaLow';
import am5geodata_moldovaLow from '@amcharts/amcharts5-geodata/moldovaLow';
import am5geodata_centralAfricanRepublicLow from '@amcharts/amcharts5-geodata/centralAfricanRepublicLow';
import am5geodata_mauritaniaLow from '@amcharts/amcharts5-geodata/mauritaniaLow';


const geoJsonRegistry = {
  iranLow: am5geodata_iranLow,
  afghanistanLow: am5geodata_afghanistanLow,
  turkmenistanLow: am5geodata_turkmenistanLow,
  sudanLow: am5geodata_sudanLow,
  chadLow: am5geodata_chadLow,
  ethiopiaLow: am5geodata_ethiopiaLow,
  azerbaijanLow: am5geodata_azerbaijanLow,
  eritreaLow: am5geodata_eritreaLow,
  burkinaFasoLow: am5geodata_burkinaFasoLow,
  maliLow: am5geodata_maliLow,
  nigerLow: am5geodata_nigerLow,  
  somaliaLow: am5geodata_somaliaLow,
  pakistanLow: am5geodata_pakistanLow,
  romaniaLow: am5geodata_romaniaLow,
  moldovaLow: am5geodata_moldovaLow,
  centralAfricanRepublicLow: am5geodata_centralAfricanRepublicLow,
  mauritaniaLow: am5geodata_mauritaniaLow,
};

export default geoJsonRegistry;